import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faArrowLeft, faStar } from '@fortawesome/free-solid-svg-icons';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { kbArchiveInterface } from 'src/app/util/interfaces/kbArchive';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { KnowledgeArchivePageService } from './service/knowledge-archive-page.service';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { KnowledgeBasePageService } from '../knowledge-base-page-rework/service/knowledge-base-page.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { AuthLoginService } from '../../auth-page/service/auth-login.service';
import { DateService } from 'src/app/services/date/date.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-knowledge-archive-page',
	templateUrl: './knowledge-archive-page.component.html',
	styleUrls: ['./knowledge-archive-page.component.scss'],
})
export class KnowledgeArchivePageComponent implements OnInit {
	icons = {
		faArrowLeft: faArrowLeft,
		faStar: faStar,
	};

	labels: LabelsInterface = {
		lbl_edocs_carregando: 'Loading',
		lbl_geral_as: 'at',
		lbl_nothing_was_found: 'Not found',
		lbl_geral_cmdb_kb: 'Knowledge base',
		lbl_geral_versao: 'Version',
		lbl_kb_pontos: 'Score',
		lbl_geral_data: 'Date',
		lbl_geral_idioma: 'Language',
		lbl_geral_status: 'Status',
		lbl_geral_summary: 'Summary',
		lbl_geral_detalhamento: 'Description',
		lbl_status_analise_causa: 'Root cause',
		lbl_asset_resolucao: 'Resolution',
		lbl_kb_aplica_se: 'Applies to',
		lbl_geral_salvar: 'Save',
		lbl_geral_cancelar: 'Cancel',
		lbl_geral_editar_informacoes: 'Edit information',
		lbl_asset_nao_possui: 'Does not have',
		lbl_geral_avaliar: 'Evaluate',
		lbl_leave_a_comment: '',
		lbl_geral_enviar: '',
		lbl_security_gerenciar: '',
		lbl_chat_enviado_com_sucesso: '',
		lbl_nao_avaliado: '',
		lbl_geral_voltar: '',
		lbl_artigo_resolveu_chamado: 'This article resolved the ticket',
		lbl_geral_sim: 'Yes',
		lbl_geral_nao: 'Not',
	};

	constructor(
		private LabelsService: LabelsService,
		private KnowledgeArchiveService: KnowledgeArchivePageService,
		private KnowledgeBaseService: KnowledgeBasePageService,
		private ActivatedRoute: ActivatedRoute,
		private Router: Router,
		private NotificationService: NotificationService,
		private AuthLoginService: AuthLoginService,
		public ProfileService: ProfileService,
		public DateService: DateService
	) {}

	isLoadingLabels = true;
	isLoadingArchive = true;
	archiveNotFound = false;
	isSendingCommentary = false;

	kbArchive: kbArchiveInterface;
	showingLine = '';
	commentary = '';
	voteValue = 0;
	idRequest = '';
	lockVote = false;

	loggedUserView = false;
	userView: any = '';

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.ActivatedRoute.params.subscribe((parameter) => {
			if (parameter && parameter.idKb) {
				this.loggedUserView = this.AuthLoginService.isLoggedIn();
				if (this.Router.url.includes('/knowledgebase/open') && this.loggedUserView)
					location.href = `knowledgebase/read/${parameter.idKb}`;

				this.KnowledgeBaseService.getKbArchive(parameter.idKb).subscribe(
					(kbArchive) => {
						this.kbArchive = kbArchive;
						this.isLoadingArchive = false;
					},
					(errorRes) => {
						this.archiveNotFound = true;
					}
				);
			}
		});

		this.userView = localStorage.getItem('sessionStatus');

		this.ActivatedRoute.queryParamMap.subscribe((parameters) => {
			this.idRequest = parameters.get('idRequest');
		});
	}

	evaluateArchive(points: number): void {
		if (this.lockVote) return;
		this.lockVote = true;

		this.voteValue = points;
		this.KnowledgeArchiveService.evaluateKb(this.kbArchive.id, points).subscribe((res) => {
			this.kbArchive.points += points;
			this.kbArchive.points_vote_qtd += 1;
		});
	}

	sendCommentary(): void {
		if (this.isSendingCommentary || this.commentary === '') return;
		this.isSendingCommentary = true;

		this.KnowledgeArchiveService.sendCommentary(this.kbArchive.id, this.commentary).subscribe((res) => {
			this.commentary = '';
			this.isSendingCommentary = false;
			this.NotificationService.setNotificationMessage(
				this.labels.lbl_chat_enviado_com_sucesso[0].toUpperCase() + this.labels.lbl_chat_enviado_com_sucesso.slice(1)
			);
		});
	}

	redirectTo(to: string): void {
		this.Router.navigate([to]);
	}

	parseInt(number: number) {
		return Number.parseInt(number.toString());
	}

	putRequestSolvedByKb(idRequest: string): void {
		const body = {
			idRequest: idRequest,
			idKb: this.kbArchive.id,
		};
		this.KnowledgeArchiveService.putRequestSolvedByKb(body).subscribe(() => {
			return this.redirectTo('/request/' + idRequest);
		});
	}
}
